export default __webpack_public_path__ + "static/media/Skey-Network-Planet-Small.3ff75322.png";